export const accountViews = {
  botConfig: {
    breadcrumb: {
      listings: "Annonces",
      current: "Agent IA",
    },
    loading: "Chargement de la configuration...",
    retry: "Réessayer",
    loadError: "Erreur lors du chargement de la configuration.",
    units: "{count} unité | {count} unités",
    faqsLabel: "FAQ",
    unitFallback: "Unité",
    active: "Actif",
    inactive: "Inactif",
    botWhatsapp: "Bot WhatsApp",
    otaIa: "IA OTA",
    saving: "Enregistrement...",
    cancel: "Annuler",
    assistant: {
      title: "Assistant WhatsApp",
      desc: "Activez le bot automatique pour répondre à vos clients sur WhatsApp.",
    },
    ota: {
      title: "IA OTA",
      desc: "Répondez automatiquement aux messages de Booking.com, Airbnb et autres OTA.",
      warn: "Activez d'abord l'assistant WhatsApp",
    },
    botName: {
      title: "Nom de l'assistant",
      desc: "Le nom que le bot utilisera pour se présenter à vos clients.",
      empty: "Aucun nom attribué",
      edit: "Modifier",
      placeholder: "Ex. : María, Sofía, Assistant virtuel...",
      save: "Enregistrer",
    },
    faqs: {
      title: "Questions fréquentes",
      desc: "Ces questions fréquentes s'appliquent à <strong>toutes les unités</strong> de cette annonce. Le bot les utilisera pour répondre à vos clients.",
      add: "Nouvelle FAQ",
      emptyText: "Vous n'avez pas encore configuré de questions fréquentes.",
      addFirst: "+ Ajouter la première FAQ",
      answerEmpty: "Aucune réponse",
      editTitle: "Modifier",
      deleteTitle: "Supprimer",
      questionLabel: "Question",
      answerLabel: "Réponse",
      questionPlaceholder: "Saisissez la question...",
      answerPlaceholder: "Saisissez la réponse que le client verra...",
      saveChanges: "Enregistrer les modifications",
    },
    addModal: {
      title: "Nouvelle question fréquente",
      questionLabel: "Question",
      questionPlaceholder: "Ex. : À quelle heure est l'arrivée ?",
      answerLabel: "Réponse",
      answerPlaceholder: "Ex. : L'arrivée se fait à partir de 15h00. Si vous arrivez plus tôt, vous pouvez déposer vos bagages...",
      submit: "Ajouter la FAQ",
    },
    deleteModal: {
      title: "Supprimer la question",
      confirm: "Êtes-vous sûr de vouloir supprimer cette FAQ ?",
      deleting: "Suppression...",
      submit: "Oui, supprimer",
    },
    types: {
      apartment: "Appartement",
      house: "Maison",
      villa: "Villa",
      hotel: "Hôtel",
      room: "Chambre",
      studio: "Studio",
      default: "Logement",
    },
    toast: {
      botOn: "Bot activé",
      botOff: "Bot désactivé",
      botError: "Erreur lors du changement de statut du bot",
      otaOn: "IA OTA activée",
      otaOff: "IA OTA désactivée",
      otaError: "Erreur lors du changement de statut de l'IA OTA",
      nameUpdated: "Nom de l'assistant mis à jour",
      nameError: "Erreur lors de l'enregistrement du nom",
      faqAdded: "FAQ ajoutée avec succès",
      faqAddError: "Erreur lors de l'enregistrement de la FAQ",
      faqUpdated: "FAQ mise à jour",
      faqUpdateError: "Erreur lors de la mise à jour de la FAQ",
      faqDeleted: "FAQ supprimée",
      faqDeleteError: "Erreur lors de la suppression de la FAQ",
    },
  },

  listingIndex: {
    title: "Annonces",
    subtitle: "Gérez la configuration centrale de chacune de vos annonces.",
    countFiltered: "{shown} annonces sur {total}",
    count: "{count} annonce | {count} annonces",
    searchPlaceholder: "Rechercher par nom, ID ou type…",
    clear: "Effacer",
    loadErrorTitle: "Impossible de charger les logements",
    retry: "Réessayer",
    emptyTitle: "Aucune annonce",
    emptyText: "Vous n'avez pas encore d'annonces enregistrées.",
    noResultsTitle: 'Aucun résultat pour « {query} »',
    noResultsText: "Essayez un autre nom, ID ou type d'annonce.",
    clearSearch: "Effacer la recherche",
    dragSearchHint: "Effacez la recherche pour réorganiser",
    dragHint: "Glissez pour réorganiser",
    units: "{count} unité | {count} unités",
    botActiveTitle: "Bot GPT actif",
    channelTitle: "Connecté à Channex",
    icalTitle: "Synchronisation iCal",
    editTitle: "Modifier le nom",
    modal: {
      title: "Modifier le nom de l'annonce",
      nameLabel: "Nom de l'annonce",
      namePlaceholder: "Ex. : Appartements Costa Sol",
      orderLabel: "Ordre de l'annonce",
      info: "Une <strong>annonce</strong> regroupe tous les établissements qui partagent la même configuration, les mêmes messages de bienvenue et les mêmes politiques. Le nom que vous définissez ici identifiera le groupe dans le panneau et dans les canaux de distribution connectés.",
      cancel: "Annuler",
      save: "Enregistrer les modifications",
    },
    types: {
      apartment: "Appartement",
      house: "Maison",
      villa: "Villa",
      hotel: "Hôtel",
      room: "Chambre",
      studio: "Studio",
      default: "Logement",
    },
    toast: {
      connectionError: "Erreur de connexion.",
      reorderSuccess: "Ordre mis à jour avec succès.",
      reorderError: "Impossible de mettre à jour l'ordre des annonces.",
      saveSuccess: "Annonce mise à jour avec succès.",
      saveError: "Erreur lors de l'enregistrement de l'annonce.",
    },
  },

  unitDetail: {
    back: "Retour à l'annonce",
    eyebrow: "Unité",
    save: "Enregistrer",
    cancel: "Annuler",
    editNameTitle: "Modifier le nom de l'unité",
    nameFallback: "Unité",
    types: {
      apartment: "Appartement",
      house: "Maison",
      villa: "Villa",
      hotel: "Hôtel",
      camping: "Camping",
      room: "Chambre",
      studio: "Studio",
      default: "Logement",
    },
    deleteLink: "Supprimer l'unité...",
    dangerNoteBefore: "Retire l'unité de l'annonce",
    dangerNoteAfter: "de WACheckin. Cette action est irréversible.",
    cards: {
      description: { title: "Description", sub: "Détails de l'unité" },
      capacity: { title: "Capacité", sub: "Clients et lits" },
      services: { title: "Équipements et commodités", sub: "Ce qu'il offre, avec photos" },
      rules: { title: "Horaires", sub: "Heures d'arrivée et de départ" },
      arrival: { title: "Instructions d'arrivée", sub: "Comment s'y rendre et entrer · avec heure d'envoi" },
      smartlocks: { title: "Serrures et accès", sub: "Comment le client entre" },
      checkout: { title: "Message de départ", sub: "Rappel de départ · modèle" },
      scheduled: { title: "Messages programmés", sub: "Messages pour cette unité uniquement" },
      unitFaq: { title: "Questions et réponses", sub: "Spécifiques à cette unité pour l'agent", badge: "IA" },
      welcome: { title: "Message de bienvenue", sub: "Message spécifique à cette unité" },
      stockExtra: {
        title: "Stock supplémentaire",
        subOff: "Désactivé · récupère les réservations d'une autre unité",
        subOn: "Renforce {name}",
        subOnGeneric: "Renforce une autre unité",
        badge: "Actif",
      },
    },
    sections: {
      aiOnlyLabel: "Questions fréquentes de l'unité",
      aiOnlyDesc: "L'agent les priorisera lorsqu'il assistera un client séjournant dans cette unité.",
      specificLabel: "Paramètres spécifiques à cette unité",
      detailLabel: "Détaillez cette unité",
      detailDesc: "Informations complémentaires que nous utilisons pour les réservations directes et pour alimenter l'agent IA.",
    },
    stockExtra: {
      title: "Stock supplémentaire",
      intro: "Sur Booking ou Airbnb, vous pouvez n'avoir qu'une seule annonce avec une capacité pour plusieurs appartements : comme un seul peut être mappé, le canal envoie toutes ces réservations sur la même unité et elles s'empilent en surréservation.",
      how: "Si vous marquez cette unité comme stock supplémentaire d'une autre, les réservations qui entrent en conflit avec l'unité principale sont enregistrées ici et le canal en est informé pour qu'elles y apparaissent aussi dans cette unité.",
      purpose: "C'est un outil de transfert : on l'active pour récupérer ce que vous aviez déjà vendu sur l'OTA et on le désactive quand chaque appartement a sa propre annonce.",
      loading: "Chargement...",
      activeLabel: "Renforce {name}",
      activeHint: "Les réservations du canal qui entrent en conflit avec {name} sont enregistrées dans cette unité.",
      activeBadge: "Actif",
      otherUnit: "une autre unité",
      warnTitle: "Ne l'activez pas si chaque appartement a déjà sa propre annonce mappée sur l'OTA :",
      warnText: "là, le canal envoie déjà chaque réservation dans son unité et, avec le stock supplémentaire activé, une réservation finirait dans un appartement qui n'est pas celui que vous avez vendu.",
      principalOf: "D'autres unités s'appuient déjà sur celle-ci :",
      chooseLabel: "Unité principale",
      chooseDesc: "Choisissez l'unité dont les réservations seront enregistrées dans « {unit} » lorsqu'elles entrent en conflit entre elles.",
      noCandidates: "Il n'y a aucune autre unité à renforcer dans cette annonce.",
      activate: "Activer le stock supplémentaire",
      change: "Changer l'unité principale",
      saving: "Enregistrement...",
      removeBtn: "Retirer le stock supplémentaire",
      removeNote: "Les réservations déjà enregistrées ici ne sont pas déplacées : elles restent dans cette unité.",
      errorCarga: "Impossible de lire la configuration du stock supplémentaire. Si vous venez de mettre à jour, rechargez la page.",
      reintentar: "Réessayer",
      toastLoadError: "Impossible de charger le stock supplémentaire.",
      toastSaveError: "Impossible d'enregistrer le stock supplémentaire.",
    },
    toast: {
      nameEmpty: "Le nom ne peut pas être vide",
      nameUpdated: "Nom mis à jour",
      nameError: "Impossible de mettre à jour le nom",
    },
  },

  miCuenta: {},
};
